import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import {
  ButtonType,
  IButtonFormData,
  IChipsFormData,
  IDropDownFormData,
  IDropDownOptions,
  IChipsValue,
  IDropDownValue,
  IImageContainerData,
  IRadioButtonGroupValue,
  ITableAction,
  ITableData,
  ITextBoxFormData,
  MaterialButtonColour,
  MaterialButtonStyle,
  breadcrumbItem,
  ITableSort,
} from "@caseworthy/cw-ui-components";
import { RadioGroupViewModel, radioTypeValue } from "src/app/modules/query-apbuilder/components/new-query/new-query.component";
import {
  QueryCategory,
  QueryConstants,
  QuerySaveType,
} from "src/app/modules/query-apbuilder/query.constants";
import { ApiQueryBuilderService } from "src/app/modules/query-apbuilder/services/api-query-builder.service";
import { DataQueryBuilderService } from "src/app/modules/query-apbuilder/services/data-query-builder.service";
import { CommonService } from "src/app/services/common.service";
import { DataService } from "src/app/services/data.services";
import {
  IGetMostUsedTablesRequest,
  IQueryKeywordDTO,
  IQuery,
  IQueryParameters,
  IQueryDataForDesignerResponse,
  IRuleWithQueryFilters,
  IQueryParamRule,
  CheckoutQueryRequest,
  IQueryTable,
  IList,
  IListItem,
} from "src/app/view-model/query-builder.view-model";

export interface dialogBoxViewModel {
  keyword ?:string; // unique identifier for popup : use this in init save and html
  header?: string;
  header_class?: string;
  sub_header?: string;
  sub_header_class?: string;
  message_title?: string;
  message_title_class?: string;
  message_footer?: string;
  message_footer_class?: string;
  message?: string;
  message_class?: string;
  action_buttons?: {
    ok_button?: string;
    ok_button2?: string;
    cancel_button?: string;
    restrictCloseIcon?: boolean;
  };
  query_details?: {
    name?: string;
    edit_name?: string;
    tag?: string[];
    description?: string;
  };
  user_detail?: {
    imagesrc?: string;
    user_name?: string;
    query_name?: string;
    query_id?: number;
    accessed_time?: string;
    label_class?: string;
  };
  query_params?: {
    param_name?: string[];
  };
  addTable?: {
    isShow?: boolean;
    tableData?: string[];
    queryName?:string;
  };
  columnJoin?: {
    columnOptions? : radioTypeValue[];
    columnName? :string;
  };
  switchQuery?: {
    isShow?: boolean;
    queryTitle?: string;
  };
  slidingDrawer?: {
    isShow?: boolean;
  };
  subQuery?: {
    pageNo: number;
    querySearched: boolean;
    enableLoadMoreButton: boolean;
    pageSize: number;
    };
  switchTabQueryTable?: {
      isShow?: boolean;      
      currentItemPrefix?: string;
      switchToItemPrefix?: string;
      currentItem?: string;
      switchToItem?: string;
  };
  new_existing_queryParam: {
    columnName: string;
    tableAliasName: string;
    queryTableId: number;
    dataType: string;
  };
  query_properties?: {
    queryTitle?: string;
    queryDescription?: string;
    queryTags: IQueryKeywordDTO[];
  };
  listLookup?: {
    isShow?: boolean;
  }
}


@Component({
    selector: "cw-confirmation-dialog-box",
    templateUrl: "./confirmation-dialog-box.component.html",
    styleUrls: ["./confirmation-dialog-box.component.scss"],
    standalone: false
})
export class ConfirmationDialogBoxComponent implements OnInit, OnDestroy {
  paramForm!: FormGroup;
  subQueryForm!: FormGroup;
  listLookupForm!: FormGroup;
  subQueryResult: any = [];
  listLookupResult: any = [];
  listItemLookupResult: any = [];
  listItemSelectedData: any = [];
  breadcrumbsFormData: breadcrumbItem[] = [];
  queryLoaderData!: IQueryDataForDesignerResponse;
  selectedExistingParam?: IQueryParameters;
  addtable_landingPage:boolean = true;
  addtable_Pagination : string = "1/2";
  subquery_PageNo = 1;
  subquery_Refresh = false;
  subquery_IsResultEmpty = false;
  listLookup_IsSearched = false; 
  listItemLookup_IsSearched = false;
  sortData : ITableSort | undefined ;

  isDataLoaded = true;
  reloadTemplateOption = false;
  formJson: ITextBoxFormData[] = [];
  queryTagsData: string[] = [];
  //#region [SubQuery JSON declaration]
  subQueryNewQueryButton: IButtonFormData = {
    label: "New Query",
    type: ButtonType.button,
    materialButtonStyle: MaterialButtonStyle.Raised,
    buttonIcon: "fa-plus",
    materialButtonColour: MaterialButtonColour.primary,
    id: "",
    name: "",
    disabled: false,
  };
  subQueryFormQueryId: ITextBoxFormData = {
    type: "text",
    required: false,
    formControlName: "subQueryFormQueryId",
    label: "Query ID",
    id: "",
    name: "",
    patternErrorMsg:
      "QueryID has a data type of INT. Please enter a numeric value.",
    validators: {
      required: false,
      patternValidation: "[0-9/]*",
      whiteSpaceValidation : false,
    },
  };
  subQueryFormQueryName: ITextBoxFormData = {
    type: "text",
    required: false,
    formControlName: "subQueryFormQueryName",
    label: "Query Name",
    id: "",
    name: "",
    patternErrorMsg:"Please enter a valid query name",
    validators: {
      required: false,
      whiteSpaceValidation : false,
    },
  };
  subQueryFormUsesTable: ITextBoxFormData = {
    type: "text",
    required: false,
    formControlName: "subQueryFormUserTable",
    label: "Uses Table",
    id: "",
    name: "",
    patternErrorMsg:"Please enter a valid uses table",
    validators: {
      required: false,
      whiteSpaceValidation : false,
    },
  };
  subQueryFormQueryDescription: ITextBoxFormData = {
    type: "text",
    required: false,
    formControlName: "subQueryFormQueryDescription",
    label: "Query Description",
    id: "",
    patternErrorMsg:"Please enter a valid query description",
    validators: {
      required: false,
      whiteSpaceValidation : false,
    },
    name: "",
  };
  subQuerySearchButton: IButtonFormData = {
    label: "Search",
    buttonIcon: "fa-magnifying-glass",
    materialButtonStyle: MaterialButtonStyle.Raised,
    materialButtonColour: MaterialButtonColour.primary,
    id: "",
    name: "",
    disabled: false,
    type: ButtonType.button,
  };
  loadMoreButton: IButtonFormData = {
    label: "Load More",
    type: ButtonType.button,
    disabled: false,
    id: "",
    name: "",
  };
  noResultFoundimageData: IImageContainerData = {
    id: "002",
    src: "/assets/images/noresultfound.png",
    alt: "No Results Found!",
    style: "",
    name: "",
  };
  subQueryTable!: ITableData;
//#endregion 

  //#region [CopyQuery JSON declaration]
  queryName: ITextBoxFormData = {
    label: "Query Name",
    required: false,
    disabled: false,
    formControlName: "QueryName",
    patternErrorMsg: QueryConstants.space_ErrorMsg,
    validators: {
      required: true,
      maxlength: QueryConstants.queryNameLength,
      whiteSpaceValidation:true
    },
    defaultValue: this.data?.query_details?.edit_name,
    type: "",
    placeholder: "",
    id: "",
    class: "",
    name: "",
  };
  //#endregion  

  //#region [Popup button JSON Declaration]
  closePopupButton: IButtonFormData = {
    label: "Cancel",
    type: ButtonType.submit,
    materialButtonStyle: MaterialButtonStyle.Basic,
    disabled: false,
    id: "search",
    name: "Search",
  };
  previousButton: IButtonFormData = {
    label: "PREVIOUS",
    type: ButtonType.submit,
    materialButtonStyle: MaterialButtonStyle.Basic,
    disabled: false,
    id: "search",
    name: "Search",
  };
  proceedButton: IButtonFormData = {
    label: "Proceed",
    type: ButtonType.button,
    disabled: false,
    id: "search",
    class: "mat-flat-button",
    name: "Search",
  };
  proceedButton2: IButtonFormData = {
    label: "Proceed",
    type: ButtonType.button,
    disabled: false,
    id: "search",
    class: "mat-flat-button",
    name: "Search",
  };
  //#endregion

  //#region [ADD Table JSON Declaration]
  primaryTableSearch: ITextBoxFormData = {
    label: "Search Table",
    id: "",
    name: "",
    class: "",
    validators: {
      required: false,
    },
    formControlName: "primaryTableSearch",
    defaultValue: "",
    type: "",
    required: false,
    suffixIcon: "search",
    isClearable: true,
  };
  primaryTableRadio: RadioGroupViewModel = {
    radioButtonGroupName: "primaryTable",
    radioButtonClass: "radio-button text-secondary f-12",
    radioGroupClass: "mat-radio-group border-bottom-radio scroll",
    defaultSelectedValue: "",
    values: [],
    required: true,
    formControlName: "primaryTable",
    disabled: false,
    validators: {
      required: true,
    },
  };
  tableAlias: ITextBoxFormData = {
    label: "TABLE ALIAS",
    id: "",
    name: "",
    class: "",
    validators: {
      required: true,
      patternValidation:QueryConstants.tableAliasRegex,
      customValidators: [this.dataService.customTableAliasValidator()],
    },
    patternErrorMsg: QueryConstants.alias_ErrorMsg,
    formControlName: "tableAlias",
    defaultValue: "",
    type: "",
    required: false,
    isClearable: false,
  };
  //#endregion
  
  //#region - join table column  
  joinColumnsRadio: RadioGroupViewModel = {
    radioButtonGroupName: "primaryTable",
    radioButtonClass: "radio-button text-secondary f-12",
    radioGroupClass: "mat-radio-group border-bottom-radio scroll",
    defaultSelectedValue: "",
    values: [],
    required: true,
    formControlName: "joinColumnsRadio",
    disabled: false,
    validators: {
      required: true,
    },
    
  };

  joinColumnsTableAlias: ITextBoxFormData = {
    label: "TABLE ALIAS",
    id: "",
    name: "",
    class: "",
    validators: {
      required: true,
      maxlength: QueryConstants.tableAliasLength,
      patternValidation:QueryConstants.tableAliasRegex,
      customValidators : [this.dataService.customTableAliasValidator(0)]
    },
    patternErrorMsg: QueryConstants.alias_ErrorMsg,
    formControlName: 'joinColumnsTableAlias',
    type: "",
    required: true,
    isClearable: false,
  };
  //# endregion - join table column

  //#region [Query Properties JSON Declaration]
  queryTitle: ITextBoxFormData = {
    label: "QUERY NAME",
    required: false,
    disabled: false,
    formControlName: "queryName",
    patternErrorMsg: QueryConstants.space_ErrorMsg,
    validators: {
      required: true,
      maxlength: QueryConstants.queryNameLength,
      whiteSpaceValidation : true
    },
    defaultValue: this.data?.query_properties?.queryTitle,
    type: "",
    placeholder: "",
    id: "",
    class: "",
    name: "",
  };
  queryDescription: ITextBoxFormData = {
    label: "QUERY DESCRIPTION",
    required: false,
    disabled: false,
    formControlName: "queryDescription",
    patternErrorMsg: QueryConstants.space_ErrorMsg,
    validators: {
      required: false,
      maxlength: QueryConstants.queryDescLength,
      whiteSpaceValidation : true
    },
    defaultValue: this.data?.query_properties?.queryDescription,
    type: "",
    placeholder: "",
    id: "",
    class: "",
    name: "",
  };
  queryTags: IChipsFormData = {
    formControlName: "queryTag",    
    label: "QUERY KEYWORDS",
    disabled: false,
    placeholder: "",
    required: false,
    id: "",
    class: "",
    patternErrorMsg: QueryConstants.keyword_ErrorMsg,
    validators: {
      required: false,
      maxlength: QueryConstants.queryKeywordLength,
      whiteSpaceValidation:true,
      patternValidation: QueryConstants.noSpaceInBetween,
    },
    defaultValue: [],
    name: "",
    icon: true
  };
  //#endregion
  // formBuilder: any;

  //#region [Add Parameter JSON Declaration]
  queryParamTypeRadio: RadioGroupViewModel = {
    radioButtonGroupName: "primaryTable",
    radioButtonClass: "radio-button",
    radioGroupClass: "mat-radio-as-columns",
    defaultSelectedValue: "",
    values: [
      { label: "New Parameter", value: "New" },
      { label: "Use Existing Parameter", value: "Existing" },
    ],
    required: true,
    formControlName: "queryParamType",
    disabled: false,
    validators: {
      required: true,
    },
  };

  newParameterName: ITextBoxFormData = {
    label: "Parameter Name",
    required: false,
    disabled: false,
    patternErrorMsg: "Parameter name must begin with '@' and have no spaces/special characters.",
    formControlName: "newParameterName",
    validators: {
      required: true,
      patternValidation: QueryConstants.atFrontAndSpaceNotBetweenValidation ,
    },
    defaultValue:
      "@" +
      this.data.new_existing_queryParam?.tableAliasName +
      "_" +
      this.data.new_existing_queryParam?.columnName,
    type: "",
    placeholder: "",
    id: "parameter-name-id",
    class: "parameter-name-class",
    name: "",
  };

  existingParameterName: IDropDownFormData = {
    label: "Parameter Name",
    required: false,
    disabled: false,
    formControlName: "existingParameterName",
    options: [],
    validators: {
      required: true,
    },
    id: "existing-parameter-name-id",
    class: "existing-parameter-name-class",
    name: "",
  };

  dataTypeParameter: IDropDownFormData = {
    label: "Data Type",
    required: false,
    disabled: false,
    formControlName: "dataTypeParameter",
    options: [],
    validators: {
      required: true,
    },
    id: "data-type-id",
    class: "data-type-class",
    name: "",
  };
  keyword:string='';
//#endregion
 
//#region [List Lookup JSON Declaration]
listLookupId: ITextBoxFormData = {
  type: "text",
  required: false,
  formControlName: "listLookupId",
  label: "ListID",
  id: "",
  name: "",
  patternErrorMsg:
    "ListID has a data type of INT. Please enter a numeric value.",
  validators: {
    required: false,
    patternValidation: "[0-9/]*",
    whiteSpaceValidation : false,
  },
};
listLookupName: ITextBoxFormData = {
  type: "text",
  required: false,
  formControlName: "listLookupName",
  label: "List Name",
  id: "",
  name: "",
  patternErrorMsg:"Please enter a valid list name",
  validators: {
    required: false,
    whiteSpaceValidation : false,
  },
};

listLookupButton: IButtonFormData = {
  label: "Search",
  buttonIcon: "fa-magnifying-glass",
  materialButtonStyle: MaterialButtonStyle.Raised,
  materialButtonColour: MaterialButtonColour.primary,
  id: "",
  name: "",
  disabled: false,
  type: ButtonType.button,
};
listLookupTable! : ITableData;
listItemLookupTable!: ITableData;
//#endregion

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: dialogBoxViewModel,
    private formBuilder: FormBuilder,
    private dataService: DataService,
    private apiQueryBuilderService: ApiQueryBuilderService,
    private commonService: CommonService,
    private dataQueryBuilderService: DataQueryBuilderService
  ) {
    this.paramForm = formBuilder.group({});
  }

  ngOnInit(): void {
    this.data?.action_buttons?.ok_button
      ? (this.proceedButton.label = this.data.action_buttons.ok_button)
      : null;
    this.data?.action_buttons?.ok_button2
      ? (this.proceedButton2.label = this.data.action_buttons.ok_button2)
      : null;
    this.data?.action_buttons?.cancel_button
      ? (this.closePopupButton.label = this.data.action_buttons.cancel_button)
      : null;
     this.keyword = this.data?.keyword ?? '';
    
    if (this.keyword !=='') {
      switch(this.keyword)
      {
        case 'popupColumnJoin':
          {
            this.proceedButton.disabled = true;
            this.paramForm.addControl(
              this.joinColumnsRadio.formControlName,
              new FormControl(
                "",
                this.dataService.getValidators(this.joinColumnsRadio.validators)
              )
            );
            this.paramForm.addControl(
              this.joinColumnsTableAlias.formControlName,
              new FormControl(
                "",
                this.dataService.getValidators(this.joinColumnsTableAlias.validators)
              )
            );

            this.paramForm.get(this.joinColumnsTableAlias.formControlName)?.valueChanges.subscribe(currentAlias => {
              this.validateJoinPopupForm();
            });
            this.joinColumnsRadio.values.push(...this.data.columnJoin?.columnOptions ?? []);
          }
      }
     }
    else {

      if (this.data?.query_params?.param_name) {
        for (let i = 0; i < this.data.query_params.param_name.length; i++) {
          this.formJson.push({
            label: this.data.query_params.param_name[i],
            required: true,
            disabled: false,
            formControlName: this.data.query_params.param_name[i].replace(
              "@",
              ""
            ),
            placeholder: this.data.query_params.param_name[i],
            validators: {
              required: true,
            },
            defaultValue: "",
            type: "",
            id: "",
            class: "",
            name: "",
          });

          this.paramForm.addControl(
            this.data.query_params.param_name[i].replace("@", ""),
            new FormControl("")
          );
        }
      }
      else if (this.data?.addTable) {

        this.paramForm.addControl(
          this.primaryTableRadio.formControlName,
          new FormControl(
            "",
            this.dataService.getValidators(this.primaryTableRadio.validators)
          )
        );
        this.paramForm.addControl(
          this.primaryTableSearch.formControlName,
          new FormControl(
            "",
            this.dataService.getValidators(this.primaryTableSearch.validators)
          )
        );
        this.paramForm.addControl(
          this.tableAlias.formControlName,
          new FormControl(
            "",
            this.dataService.getValidators(this.tableAlias.validators)
          )
        );
        this.getMostUsedTableMethod();
      }
      else if (this.data?.query_details?.edit_name) {
        this.paramForm.addControl(
          this.queryName.formControlName,
          new FormControl(
            "",
            this.dataService.getValidators(this.queryName.validators)
          )
        );
        this.paramForm.controls[this.queryName.formControlName].setValue(
          this.data?.query_details?.edit_name
        );
      }
      else if (this.data.subQuery) {
        this.createSubqueryForm();
      }
      else if (this.data?.listLookup?.isShow) {
        this.initializeListForm();
      }
      else if (this.data?.new_existing_queryParam) {
        this.queryLoaderData =
          this.dataQueryBuilderService.getCurrentVersionOfQuery();
        const tableNameBreadScrum: breadcrumbItem[] = [
          {
            index: 0,
            link: {
              label: this.queryLoaderData.query.queryName,
              id: "query-table-name-button",
              disabled: true,
              name: this.queryLoaderData.query.queryName,
              ellipsisLength: 20,
            },
          },
          {
            index: 1,
            link: {
              label: this.data.new_existing_queryParam.tableAliasName + "." + this.data?.new_existing_queryParam?.columnName,
              id: "query-column-name-button",
              disabled: true,
              name: this.data.new_existing_queryParam.tableAliasName + "." + this.data?.new_existing_queryParam?.columnName,
              ellipsisLength: 20,
            },
          },
        ];

        this.breadcrumbsFormData = tableNameBreadScrum;
        this.paramForm.addControl(
          this.queryParamTypeRadio.formControlName,
          new FormControl(
            "New",
            this.dataService.getValidators(this.queryParamTypeRadio.validators)
          )
        );
        this.queryParamTypeRadio.defaultSelectedValue = "New";
        this.paramForm.addControl(
          this.newParameterName.formControlName,
          new FormControl(
            "",
            this.dataService.getValidators(this.newParameterName.validators)
          )
        );
        this.paramForm.addControl(
          this.dataTypeParameter.formControlName,
          new FormControl(
            "",
            this.dataService.getValidators(this.dataTypeParameter.validators)
          )
        );
        this.getDataTypeParamOptions();
        this.getExistingParamOptions();
      }
      else if (this.data?.query_properties) {
        const queryTags = this.data?.query_properties?.queryTags.map(
          (mapping) => {
            return mapping.keyword;
          }
        );

        this.paramForm.addControl(
          this.queryTitle.formControlName,
          new FormControl("", this.dataService.getValidators(this.queryTitle.validators))
        );
        this.paramForm.addControl(
          this.queryDescription.formControlName,
          new FormControl("", this.dataService.getValidators(this.queryDescription.validators))
        );
        this.paramForm.addControl(
          this.queryTags.formControlName,
          new FormControl("", this.dataService.getValidators(this.queryTags.validators))
        );
        this.paramForm.controls[this.queryTags.formControlName].patchValue(
          queryTags
        );
        this.queryTags.defaultValue = queryTags;
      }
      else if (this.data?.slidingDrawer?.isShow) {
        this.proceedButton2.id = "bg-success";
      }
      else if (this.data?.switchQuery?.isShow) {
        this.proceedButton.id = "bg-success";
        this.proceedButton2.id = "bg-success";
      }
    }
  }

  setSelectedColumnToJoin(event: IRadioButtonGroupValue)
  {
    let tableName = event.selectedValue?.split('.')[2];
    this.paramForm.get(this.joinColumnsTableAlias.formControlName)?.patchValue(tableName);
  }

  validateJoinPopupForm() {
    let option = this.paramForm.get(this.joinColumnsRadio.formControlName)?.value ?? '';
    this.proceedButton.disabled = (this.paramForm.get(this.joinColumnsTableAlias.formControlName)?.invalid || option === '');
    if(option !=='')
    {
      this.dataService.validateAllFields(this.paramForm);
    }
  }

  getColumnJoinPopupError() {
    let option = this.paramForm.get(this.joinColumnsRadio.formControlName)?.value ?? '';
    return (option === '') ? 'Please select a column from the list' : '';
  }

  createSubqueryForm() {
    const controlFroup = {
      [this.subQueryFormQueryId.formControlName]: [
        "",
        this.dataService.getValidators(this.subQueryFormQueryId.validators),
      ],
      [this.subQueryFormQueryName.formControlName]: ["", this.dataService.getValidators(this.subQueryFormQueryName.validators)],
      [this.subQueryFormUsesTable.formControlName]: ["", this.dataService.getValidators(this.subQueryFormUsesTable.validators)],
      [this.subQueryFormQueryDescription.formControlName]: ["", this.dataService.getValidators(this.subQueryFormQueryDescription.validators)],
    };
    this.subQueryForm = this.formBuilder.group(controlFroup);
  }
  initializeListForm(){
    const controlGroup = {
      [this.listLookupId.formControlName]: ["", this.dataService.getValidators(this.listLookupId.validators)],
      [this.listLookupName.formControlName]: ["", this.dataService.getValidators(this.listLookupName.validators)],
    };
    this.listLookupForm = this.formBuilder.group(controlGroup);
    this.proceedButton.label = "";
  }

  searchSubquery(pageNo: number, isSearchButton : boolean) {
    if(this.subQueryForm.invalid){
      this.subQueryResult = [];
      return;
    }
    this.subquery_IsResultEmpty = false;
    if (this.data?.subQuery) {
      this.data.subQuery.querySearched = false;
    }
    if(isSearchButton){
      this.sortData = undefined;
      this.subquery_Refresh = false;
    }
    const formData = this.subQueryForm.value;
    const payload = {
      pageNo: pageNo,
      queryTable: formData.subQueryFormUserTable,
      description: formData.subQueryFormQueryDescription,
      queryID: -1,
      categoryID: 4,
      queryName: formData.subQueryFormQueryName,
      pageSize: this.data?.subQuery?.pageSize,
      sortData: this.sortData,
    };

    if (formData.subQueryFormQueryId > 0) {
      payload.queryID = formData.subQueryFormQueryId;
    }
    if(pageNo === 1 || this.sortData?.sortDirection !== undefined){
      this.subQueryResult = [];
    }   
    this.apiQueryBuilderService.getSearchedQueryData(payload).subscribe({
      next: (response) => {
        if(this.data?.subQuery){
          this.data.subQuery.querySearched = true;
          this.data.subQuery.enableLoadMoreButton = true;
          if(response.length < this.data?.subQuery?.pageSize){
            this.data.subQuery.enableLoadMoreButton = false;
          }
        }
        if (response && response.length) {
          this.subquery_Refresh = true;
          
          response.forEach((val: IQuery) => {
              this.subQueryResult.push({
                Edit: "ACTION",
                "Query ID": `${val.queryID}`,
                "Query Name": val.queryName,
                "Query Description": val.description,
              });
          });
          this.subQueryTable = {
            columns: ["Edit", "Query ID", "Query Name", "Query Description"],
            name: "",
            dataSource: this.subQueryResult,
            hyperlinkColumns: [],
            isFilterRequired: false,
            isPaginationRequired: false,
            isSortRequired: true,
            totalLength: false,
            actionButtons: [],
            paginationOptions: [],
            id: "subQueryTable",
            class: "",
            title: "",
            rowClickAction: true,
            isLoadMoreButton: true,
            collapse: {
              enableCollapse: true,
              displayedColumnsCount: 3,
              showIcon: true,
            }
          };
        }
        else{
          this.subquery_IsResultEmpty = true;
        }
      },
      error: (e) => {
        this.commonService.openSnackBar(QueryConstants.query_NotFound, 1000, e);
      },
    });
  }

  subqueryTableEvent(event: ITableAction) {
    if (event.event === 'rowClick') {
      this.dialogRef.close(event.rowElement["Query ID"]);
    }
    else if (event.event === 'editIconClick') {
      let selectedQueryToEdit = event.rowElement["Query ID"];
      let url = `${window.location.origin}${window.location.pathname}?QueryID=${selectedQueryToEdit}&ParentQueryId=${this.dataService.queryId}`;
      let newWindowResponse = this.openNewPopupWindow(url);
      let newPopupWindow = newWindowResponse?.childWindow;
      if (newPopupWindow) {
        newPopupWindow.focus();
        newPopupWindow.sessionStorage.setItem('queryId', selectedQueryToEdit);
        if (newWindowResponse?.monitorRequired) {
          this.monitorNewWindow(newPopupWindow, 'QueryManager');
        }
      }
    }
  }

  subQueryNewQueryButtonAction() {
    let url = `${window.location.origin}/Query/QueryAdd?QueryCategory=${QueryCategory.Sub_Query}&ParentQueryId=${this.dataService.queryId}`;
    let newWindowResponse = this.openNewPopupWindow(url);
    let newPopupWindow = newWindowResponse?.childWindow;
    if (newPopupWindow) {
      newPopupWindow.focus();
      if (newWindowResponse?.monitorRequired) {
        this.monitorNewWindow(newPopupWindow, 'QueryManager');
      }
    }
  }

  listLookup(){
    if (this.listLookupForm.invalid)
      return;

    this.listLookupResult = [];
    this.listItemLookup_IsSearched = false;
    this.listItemSelectedData = [];
    
    this.apiQueryBuilderService.getListData(this.listLookupForm.value?.listLookupId,this.listLookupForm.value?.listLookupName).subscribe({
      next: (response) => {
        this.listLookup_IsSearched = true;
        response.forEach((val: IList) => {
          this.listLookupResult.push({
            "ListID": `${val.listId}`,
            "List Name": val.listName,
          });
        });
        this.listLookupTable = {
          columns: ["ListID", "List Name"],
          name: "",
          dataSource: this.listLookupResult,
          hyperlinkColumns: [],
          isFilterRequired: false,
          isPaginationRequired: false,
          isSortRequired: false,
          totalLength: false,
          actionButtons: [],
          paginationOptions: [],
          id: "listLookup",
          class: "tbl-striped p15",
          title: "",
          rowClickAction: true,
          isLoadMoreButton: true,
        };
      },
      error: (e) => {
      },
    });
  }

  listSelectedEvent(event: ITableAction){
    this.listItemLookupResult = [];
    this.listItemLookup_IsSearched = false;
    this.listItemSelectedData = [];

    this.apiQueryBuilderService.getListItemData(event.rowElement["ListID"]).subscribe({
      next: (response) => {
        this.listItemLookupResult = [];
        this.listItemLookup_IsSearched = true; 
        
        response.forEach((val: IListItem) => {
          this.listItemLookupResult.push({
            "ListID": `${val.listValue}`,
            "List Name": val.listLabel,
          });
        });
        this.listItemLookupTable = {
          columns: ["ListID", "List Name"],
          name: "",
          dataSource: this.listItemLookupResult,
          hyperlinkColumns: [],
          isFilterRequired: false,
          isPaginationRequired: false,
          isSortRequired: false,
          isCheckBoxSelectionRequired: this.listItemLookupResult.length > 0 ? true : false,
          totalLength: false,
          actionButtons: [],
          paginationOptions: [],
          id: "listItemLookup",
          class: "tbl-striped p15",
          title:"",
          subtitle: "List Name : "+ event.rowElement["List Name"],
          rowClickAction: false,
          isLoadMoreButton: true,
        };

        if(this.listItemLookupResult.length > 0){
          this.data?.action_buttons?.ok_button
            ? (this.proceedButton.label = this.data.action_buttons.ok_button)
            : null;
        }
        else{
          this.proceedButton.label = "";
        }
      },
      error: (e) => {
      },
    });
  }

  onSelectedData(data: any) {
    this.listItemSelectedData = data;
  }

  openNewPopupWindow(url: string) {
    let newPopupWindow = this.dataService.getChildPopupWindow();
    if (this.dataService.isChildPopupWindowOpened === true && newPopupWindow) {
      // window was alredy opened.
      this.dataService.setLocalPopupState({ isOpen: true, window: newPopupWindow });
      newPopupWindow.focus();
      const queryId = newPopupWindow.sessionStorage.getItem('queryId');
      if (queryId) {
        this.checkinQuery(Number(queryId));
        newPopupWindow.sessionStorage.removeItem('queryId');
      }
      newPopupWindow.location = url;
      return { childWindow: newPopupWindow, monitorRequired: false };
    }
    else {
      // child is not instantiated , open and monitor
      newPopupWindow = this.dataService.openChildPopupWindow(url);
      if (newPopupWindow) {
        this.dataService.setLocalPopupState({ isOpen: true, window: newPopupWindow });
        this.dataService.isChildPopupWindowOpened = true;
        newPopupWindow.sessionStorage.removeItem('queryId');
        return { childWindow: newPopupWindow, monitorRequired: true };
      }
    }
    return { childWindow: newPopupWindow, monitorRequired: false };
  }

  /**
   * Handle the new Popup window for 'New Query' and 'Edit Query' for selecting subquery option in filter rules
   * @param newPopupWindow - new broswer window instance
   * @param routeToMonitor - URL to track and retireve the queryId
   * @param queryBeingEditedInNewWindow - queryId chosen in the next current screen
   */
  monitorNewWindow(newPopupWindow: Window, routeToMonitor: string, queryBeingEditedInNewWindow?: string) {
    if (newPopupWindow) {
      newPopupWindow.focus();
      let lastKnownPath = '';
      var timer = setInterval(() => {
        if (newPopupWindow?.closed) {
          clearInterval(timer);
          this.dataService.isChildPopupWindowOpened = false;
          if (routeToMonitor === 'QueryManager') {
            if (lastKnownPath.indexOf(routeToMonitor) > -1 && queryBeingEditedInNewWindow !== undefined) {
              this.checkinQuery(Number(queryBeingEditedInNewWindow));
            }
            this.dialogRef.close(queryBeingEditedInNewWindow);
          }
        }
        else {
            lastKnownPath = newPopupWindow.location.pathname;
            if (newPopupWindow.location.pathname.indexOf(routeToMonitor) > -1) {
              queryBeingEditedInNewWindow = `${new URLSearchParams(newPopupWindow.location.search)?.get('QueryID')}`;
            }
        }
      }, 500);
    }
  }

  checkinQuery(queryId: number) {
    const body: CheckoutQueryRequest = {
      queryID: queryId,
      currentUserID: this.dataService.currentUser?.userID,
    };
    this.apiQueryBuilderService.checkinQuery(body).subscribe();
  }

  proceedMethod() {
    this.dataService.validateAllFields(this.paramForm);
    if (this.keyword !== '') {
      switch (this.keyword) {
        case 'popupColumnJoin':
          {
            let column = this.paramForm.get(this.joinColumnsRadio.formControlName)?.value;
            let currentAlias = this.paramForm.get(this.joinColumnsTableAlias.formControlName)?.value?.trim();
            let dataSelected = { column: column, tableAlias: currentAlias };
            this.dialogRef.close(dataSelected);
          }
      }
    }
    else {
      if (this.data?.query_params?.param_name) {
        if (this.paramForm.valid) {
          this.dialogRef.close(this.paramForm.value);
        }
      } else if (this.data?.addTable) {
        const tableName = this.paramForm.get(
          this.primaryTableRadio.formControlName
        )?.value;
        let tableAlias = this.paramForm.get(
          this.tableAlias.formControlName
        )?.value;

        if (this.addtable_landingPage) {
          if (tableName === "" || tableName === undefined) {
            alert("Please select one table");
            return;
          }
          this.addtable_landingPage = false;

          this.proceedButton.label = "COMPLETE";
          this.proceedButton.id = "bg-success";

          this.data.header = "Create A Table Alias";
          this.data.sub_header = `Create an alias for this table being added to "<strong>${this.data.addTable.queryName}</strong>". `;
          this.addtable_Pagination = "2/2";

          this.tableAlias.defaultValue = this.paramForm.value[this.primaryTableRadio.formControlName].split(".")[1];
        }
        else {
          if (tableName === "" || tableName === undefined) {
            alert("Please select one table");
          }
          if (this.paramForm.valid) {
            this.dialogRef.close({ tableName, tableAlias });
          }
        }
      } else if (
        this.data?.query_details?.edit_name ||
        this.data?.query_properties
      ) {
        if (this.paramForm.valid) {
          if(this.data?.query_properties){
            let data = Object.assign(this.paramForm.value, {[this.queryTags.formControlName] :this.queryTagsData}) ;
            this.dialogRef.close(data);
          } else{
            this.dialogRef.close(this.paramForm.value);
          }
        }
      } else if (this.data?.switchQuery?.isShow || this.data?.slidingDrawer?.isShow) {
        this.dialogRef.close(QuerySaveType.NoSave);
      } else if (this.data?.new_existing_queryParam) {
        if (this.paramForm.valid) {
          let queryParamBody!: IQueryParameters;
          const sortOrderRule =  this.dataQueryBuilderService.getCurrentVersionOfQuery()?.ruleWithQueryFilters?.filter(x=> x.queryTableId == this.data.new_existing_queryParam.queryTableId)?.length;
          let rulesBody: IRuleWithQueryFilters = {
            ruleId: this.dataQueryBuilderService.getNewTempId(),
            leftOperandType: 1,
            leftOperand: this.data.new_existing_queryParam.tableAliasName + "." + this.data.new_existing_queryParam.columnName,
            comparison: 1,
            rightOperandType: 4,
            rightOperand: "",
            queryId: this.dataQueryBuilderService.getCurrentVersionOfQuery().query.queryID,
            queryTableId: this.data.new_existing_queryParam.queryTableId,
            sortOrder: (sortOrderRule && sortOrderRule > 0 ) ? sortOrderRule + 1 : 1
          }
          if (
            this.paramForm.value[this.queryParamTypeRadio.formControlName] ==
            "New"
          ) {
            queryParamBody = {
              queryId:
                this.dataQueryBuilderService.getCurrentVersionOfQuery().query
                  .queryID,
              parameterName:
                this.paramForm.value[this.newParameterName.formControlName],
              dataType: Number(
                this.paramForm.value[this.dataTypeParameter.formControlName]
              ),
              defaultValue: "-1",
              required: true,
            };
            rulesBody.rightOperand = this.paramForm.value[this.newParameterName.formControlName]
          } else {
            rulesBody.rightOperand = this.paramForm.value[this.existingParameterName.formControlName]
          }
          let queryParamRules: IQueryParamRule = { queryParam: queryParamBody, rules: rulesBody }
          if (this.queryLoaderData.ruleWithQueryFilters?.filter((test) => 
            (test.leftOperand == rulesBody.leftOperand) && (test.rightOperand == rulesBody.rightOperand && test.rightOperandType === rulesBody.rightOperandType) 
            && (test.comparison == rulesBody.comparison) && (test.queryTableId == this.data.new_existing_queryParam.queryTableId)).length == 0) {
              if (this.paramForm.value[this.queryParamTypeRadio.formControlName] == "New" 
                && this.queryLoaderData.queryParameters.filter(param => param.parameterName == queryParamBody.parameterName).length > 0) {
                  (queryParamRules['queryParam'] = undefined);
              }
              this.dialogRef.close(queryParamRules);
          } else {
            this.commonService.openSnackBar(
              QueryConstants.duplicateQueryParam_ErrorMsg,
              5000,
              "error"
            );
          }
        } else {
          this.dataService.validateAllFields(this.paramForm)
        }
      }
      else if(this.data?.listLookup?.isShow){
        if(this.listItemSelectedData.length == 0){
          alert("Please select atleast one list id");
        }
        else{
          this.dialogRef.close(this.listItemSelectedData.map((a: { [x: string]: any; }) => a["ListID"]));
        }
      }
      else {
        this.dialogRef.close(true);
      }
    }
  }

  proceedMethod2() {
    if (this.data?.switchQuery?.queryTitle || this.data?.slidingDrawer?.isShow)
      this.dialogRef.close(QuerySaveType.Save);
  }
  previousButtonAction(){
    if (this.data?.addTable) {
      this.addtable_landingPage = true;

      this.proceedButton.label = "NEXT";
      this.proceedButton.id = "";

      this.data.header = "Select A Table";
      this.data.sub_header = `Add a table to the query, "<strong>${this.data.addTable.queryName}</strong>" by choosing one below.`;
      this.addtable_Pagination = "1/2";
      this.primaryTableRadio.defaultSelectedValue = this.paramForm.value[this.primaryTableRadio.formControlName];
      this.primaryTableSearch.defaultValue = this.paramForm.value[this.primaryTableSearch.formControlName];
    }
  }

  searchTables(event: any) {
    if (event === "") {
      alert("Please enter a table name to search");
      return;
    }
    this.primaryTableRadio.values = [];
    this.reloadTemplateOption = false;
    const request: IGetMostUsedTablesRequest = {
      QueryCategoryID: 3,
      SchemaName: "",
      ObjectName: event,
      ShowTablesOnly: false,
      CurrentUserID: this.dataService.currentUser?.userID,
    };
    this.apiQueryBuilderService.getSearchedTableData(request).subscribe({
      next: (response) => {
        if (response && response.length > 0) {
          response.forEach(
            (element: { schemaName: string; objectName: string }) => {
              this.primaryTableRadio.values.push({
                label: element.schemaName + "." + element.objectName,
                value: element.schemaName + "." + element.objectName,
              });
            }
          );
        }
        this.isDataLoaded = true;
        this.reloadTemplateOption = true;
      },
    });
  }

  getMostUsedTableMethod() {
    this.reloadTemplateOption = false;
    this.primaryTableRadio.values = [];
    const getMostUsedTablesRequst: IGetMostUsedTablesRequest = {
      QueryCategoryID: 3,
      SchemaName: "",
      ObjectName: "",
      ShowTablesOnly: false,
      CurrentUserID: this.dataService.currentUser?.userID,
    };
    this.apiQueryBuilderService
      .getMostUsedTableData(getMostUsedTablesRequst)
      .subscribe({
        next: (response) => {
          if (response && response.length > 0) {
            response.forEach(
              (element: { schemaName: string; objectName: string }) => {
                this.primaryTableRadio.values.push({
                  label: element.schemaName + "." + element.objectName,
                  value: element.schemaName + "." + element.objectName,
                });
              }
            );
            this.reloadTemplateOption = true;
            this.isDataLoaded = true;
          }
        },
      });
  }

  getSelectedTemplateData(event: IRadioButtonGroupValue) {
   
    this.paramForm.patchValue({
      primaryTable: event.selectedValue,
    });
  }

  getSelectedQueryParamRadioData(data: IRadioButtonGroupValue) {
    this.queryParamTypeRadio.defaultSelectedValue = data.selectedValue;
    if (data.selectedValue == "Existing") {
      this.paramForm.addControl(
        this.existingParameterName.formControlName,
        new FormControl(
          "",
          this.dataService.getValidators(this.existingParameterName.validators)
        )
      );
      this.paramForm.removeControl(this.newParameterName.formControlName);
      this.paramForm.removeControl(this.dataTypeParameter.formControlName);
    } else if (data.selectedValue == "New") {
      this.paramForm.addControl(
        this.newParameterName.formControlName,
        new FormControl(
          "",
          this.dataService.getValidators(this.newParameterName.validators)
        )
      );
      this.paramForm.addControl(
        this.dataTypeParameter.formControlName,
        new FormControl(
          "",
          this.dataService.getValidators(this.dataTypeParameter.validators)
        )
      );
      this.paramForm.controls[this.dataTypeParameter.formControlName].setValue(this.dataTypeParameter.options?.filter((dataTypeOption)=>dataTypeOption.listLabel == this.data.new_existing_queryParam.dataType)?.[0]?.listValue);
      this.paramForm.removeControl(this.existingParameterName.formControlName);
    }
  }

  getDataTypeParamOptions() {
    Object.keys(QueryConstants.dataType).forEach((val: string) => {
      const option: IDropDownOptions = {
        disabled: "false",
        listItemId: val,
        listLabel: QueryConstants.dataType[Number(val)],
        listValue: val,
      };
      this.dataTypeParameter.options?.push(option);
    });   
    this.paramForm.controls[this.dataTypeParameter.formControlName].setValue(this.dataTypeParameter.options?.filter((dataTypeOption)=>dataTypeOption.listLabel == this.data.new_existing_queryParam.dataType)?.[0]?.listValue);
  }

  getExistingParamOptions() {
    if (
      this.queryLoaderData &&
      this.queryLoaderData.queryParameters &&
      this.queryLoaderData.queryParameters.length > 0
    ) {
      this.existingParameterName.options = [];
      for (let i = 0; i < this.queryLoaderData.queryParameters.length; i++) {
        const option: IDropDownOptions = {
          disabled: "false",
          listItemId: this.queryLoaderData.queryParameters[i].parameterName,
          listLabel: this.queryLoaderData.queryParameters[i].parameterName,
          listValue: this.queryLoaderData.queryParameters[i].parameterName,
        };
        this.existingParameterName.options?.push(option);
      }
    }
  }

  getExistingParamData(data: IDropDownValue) {
    this.selectedExistingParam = this.queryLoaderData.queryParameters.filter(
      (x: IQueryParameters) => x.parameterName == data.selectedValue
    )[0];
  }

  getSelectedQueryTags(data: IChipsValue){
    if(data.enteredValue){
      this.queryTagsData = data.enteredValue;
    }
  }
  sortChangeEvent(event : ITableSort){
    this.sortData = undefined;
    if (event?.sortDirection !== "") {
      event.columnName = QueryConstants.columnTitle[event.columnName];
      this.sortData = event;
       this.searchSubquery(this.subquery_PageNo, false);
    }
  }

  ngOnDestroy(): void {
    if (this.dataService.isChildPopupWindowOpened == true) {

      this.dataService.closeChildPopupWindow();
      // if we get any issues with checkin-query uncomment below code: 
      // this will make hold destroy for a while so that monitorwindow() will get enough interval execute once after closing newPopupWindow.
      
      //setTimeout(()=>{console.log('wait is over, hoping a checkin happen alredy')}, 600);
    }
  }
}
